var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarSolid = function SvgCarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.25a.75.75 0 0 0-.696.471l-2 5A.75.75 0 0 0 2.25 11v6c0 .414.336.75.75.75h1.354a2.751 2.751 0 0 0 5.292 0h4.707a2.751 2.751 0 0 0 5.293 0H21a.75.75 0 0 0 .75-.75v-4A2.75 2.75 0 0 0 19 10.25h-.64l-3.774-4.719A.75.75 0 0 0 14 5.25H5Zm6.25 5H4.108l1.4-3.5h5.742v3.5Zm1.5 0v-3.5h.89l2.8 3.5h-3.69Zm-7 6.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm10 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    fill: "currentColor"
  })));
};
export default SvgCarSolid;